import { IConfigsType } from '../../types'
import { IDateOptionType } from '../../variables/hooks/common/date/types'

const pnlRankings = ({
  brand,
  startDate,
  dateOptions,
}: {
  brand: string
  startDate?: string
  dateOptions: IDateOptionType
}): IConfigsType => ({
  [brand]: {
    '/:brand/pnl-rankings': {
      disableAutoMargin: true,
      variables: [
        'corporateGroup',
        {
          type: 'pnlRankings',
          dateOptions: {
            types: ['week', 'period', 'quarter', 'year'],
            startDate,
            endDate: 'yesterday',
            ...dateOptions,
          },
        },
      ],
      groupFilter: {
        api: 'legalEntityWithoutLocationsFilter',
        width: 300,
      },
      dateFilter: {
        types: ['week', 'period', 'quarter', 'year'],
        startDate,
        endDate: 'yesterday',
      },
      title: {
        type: 'title',
        title: 'Rankings',
      },
      filterBy: {
        type: 'grid',
        children: {
          category: {
            type: 'select',
            value: 'pnlRankings.category.value',
            onChange: 'pnlRankings.category.onChange',
            options: 'pnlRankings.category.options',
            label: 'Category',
            search: true,
            width: '300px',
          },
          rankBy: {
            type: 'select',
            value: 'pnlRankings.rankBy.value',
            onChange: 'pnlRankings.rankBy.onChange',
            options: 'pnlRankings.rankBy.options',
            label: 'Rank By',
            width: '260px',
          },
        },
      },
      downloadPAndL: {
        titleMargin: '20px 0px 0px',
        type: 'download-csv',
        api: 'pAndLRankings',
        fileName: 'Ranking',
        message: 'Download Ranking as CSV',
        fields: [
          {
            key: 'rowIndex',
            title: 'Rank',
          },
          'groupInfo',
          {
            key: '<%- JSON(pnlRankings.columns) %>',
            hide: '<%- _.isUndefined(pnlRankings.columns) %>',
          },
        ],
      },
      pAndLRankings: {
        type: 'table-v2',
        api: 'pAndLRankings',
        columns: [
          {
            key: 'rowIndex',
            title: 'Rank',
            align: 'center',
          },
          {
            key: '<%- JSON(corporateGroup?.tableColumns.slice(0, 1)) %>',
            hide: '<%- _.isUndefined(corporateGroup) %>',
            width: 'initial',
          },
          {
            key: '<%- JSON(pnlRankings.columns) %>',
            hide: '<%- _.isUndefined(pnlRankings.columns) %>',
            align: 'center',
          },
        ],
      },
    },
  },
})

export default pnlRankings
